var _path, _path2, _path3, _path4, _circle, _path5, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandardCost({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7188 25.1954C11.7188 25.197 11.7188 25.1985 11.7188 25.2C11.7189 28.6928 11.9889 32.9935 12.91 37.5002H37.5V9.91895C36.7554 9.91895 36.0109 10.0772 35.3181 10.3937C32.6732 11.6022 28.1631 13.5765 24.8795 14.5594C22.1749 15.3691 18.6381 16.0043 15.997 16.4128C13.7887 16.7543 12.0223 18.4549 11.8704 20.6843C11.7847 21.9424 11.7188 23.4703 11.7188 25.1954Z",
    fill: "#C8D1EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5 65.4215C37.0324 65.4215 36.5647 65.3501 36.1233 65.2075C21.0976 60.3502 15.1236 48.3302 12.91 37.5H37.5V65.4215Z",
    fill: "#EFEFFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 9.9187C38.2444 9.9187 38.989 10.0769 39.6816 10.3933C42.3264 11.6017 46.8366 13.5763 50.1201 14.5593C52.8247 15.369 56.3618 16.0044 59.0029 16.4128C61.2112 16.7544 62.978 18.455 63.1299 20.6843C63.3892 24.4903 63.4645 30.7647 62.0879 37.4998H37.5V9.9187Z",
    fill: "#EFEFFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.09 37.5C59.8764 48.3302 53.9024 60.3502 38.8768 65.2074C38.4354 65.3501 37.9677 65.4215 37.5 65.4215V37.5H62.09Z",
    fill: "#C8D1EA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 11.5,
    fill: "#C8D1EA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5166 23.6875C45.1379 23.6875 51.3125 29.8923 51.3125 37.5127C51.3125 45.1319 45.1053 51.3037 37.5166 51.3037H37.2666V51.3086C29.7588 51.1751 23.6875 45.0481 23.6875 37.5127C23.6875 29.8932 29.8946 23.6876 37.5166 23.6875ZM37.6016 26.6494C37.1265 26.6494 36.7363 27.0396 36.7363 27.5146V29.335C34.4438 29.5453 32.624 31.4099 32.624 33.832C32.6242 36.3373 34.6751 38.3779 37.1719 38.3779H38.1572C39.708 38.3779 40.9746 39.6173 40.9746 41.1602C40.9745 42.7065 39.7043 43.9756 38.1572 43.9756H33.1611C32.6861 43.9756 32.2959 44.3658 32.2959 44.8408C32.2959 45.3159 32.6861 45.7061 33.1611 45.7061H36.7529V47.4775C36.7531 47.9525 37.1432 48.3418 37.6182 48.3418C38.1357 48.3417 38.4833 47.9433 38.4834 47.4775V45.6914C40.8271 45.5018 42.7127 43.5762 42.7129 41.1602C42.7129 38.6611 40.6605 36.6477 38.166 36.6475H37.1797C35.6345 36.6474 34.3635 35.3464 34.3633 33.832C34.3633 32.3211 35.6308 31.0499 37.1797 31.0498H41.502C41.9769 31.0498 42.3671 30.6596 42.3672 30.1846C42.3672 29.7095 41.977 29.3193 41.502 29.3193H38.4658V27.5146C38.4658 27.0397 38.0764 26.6497 37.6016 26.6494Z",
    fill: "#027BC7",
    stroke: "#027BC7",
    strokeWidth: 0.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38,
    cy: 69.5,
    rx: 9,
    ry: 1.5,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardCost);
export default __webpack_public_path__ + "static/media/standardCost.1352c1f3c1d70b260a4383f73a62d78f.svg";
export { ForwardRef as ReactComponent };